import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';
const {
  playerControlsThemes: { inverted: controlsTheme },
} = Colors;

export const StyledControlBar = styled.div`
  width: 100%;
  background: ${controlsTheme.background};
  border-radius: 5px;
  margin-top: 3px;
  padding: 4px;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  min-height: 32px;

  .default-controls {
    display: flex;
    gap: 5px;
  }

  .ant-btn {
    color: ${controlsTheme.buttonsForeground};
    background-color: ${controlsTheme.buttonsBackground};
    border: none;
    border-radius: 4px;
    &:hover {
      color: ${controlsTheme.buttonsForegroundHover};
      background-color: ${controlsTheme.buttonsBackgroundHover};
    }

    &[disabled],
    &[disabled]:hover {
      color: ${controlsTheme.buttonsForeground};
      background-color: ${controlsTheme.buttonsBackground};
      opacity: 0.5;
    }
  }

  &.fullscreen {
    border-radius: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding: 10px;

    .ant-btn {
      padding: 0px 20px;
      height: 40px;
      background-color: ${controlsTheme.buttonsBackgroundFullscreen};
      font-size: 120%;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    &.fullscreen {
      .score-board {
        display: none;
      }
    }
  }
`;
